import composeInstallation from '../utils/composeInstallation'

const install = composeInstallation({
  name: 'gtag',
  scriptId: 'gtag-jssdk',
  makeScriptUri: ({ clientId }) => `https://www.googletagmanager.com/gtag/js?id=${clientId}`
})
export { install }